/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiAccountMeGet } from '../fn/account/api-account-me-get';
import { ApiAccountMeGet$Params } from '../fn/account/api-account-me-get';
import { apiAccountMeprofileGet } from '../fn/account/api-account-meprofile-get';
import { ApiAccountMeprofileGet$Params } from '../fn/account/api-account-meprofile-get';
import { ManageUserProfile } from '../models/manage-user-profile';

@Injectable({ providedIn: 'root' })
export class AccountService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiAccountMeGet()` */
  static readonly ApiAccountMeGetPath = '/api/account/me';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAccountMeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAccountMeGet$Response(params?: ApiAccountMeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return apiAccountMeGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAccountMeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAccountMeGet(params?: ApiAccountMeGet$Params, context?: HttpContext): Observable<string> {
    return this.apiAccountMeGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiAccountMeprofileGet()` */
  static readonly ApiAccountMeprofileGetPath = '/api/account/meprofile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAccountMeprofileGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAccountMeprofileGet$Response(params?: ApiAccountMeprofileGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ManageUserProfile>> {
    return apiAccountMeprofileGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAccountMeprofileGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAccountMeprofileGet(params?: ApiAccountMeprofileGet$Params, context?: HttpContext): Observable<ManageUserProfile> {
    return this.apiAccountMeprofileGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<ManageUserProfile>): ManageUserProfile => r.body)
    );
  }

}
